import { IState } from '../../store';

export const selectHasNewObject = (state: IState): boolean => {
  return Boolean(state.offerData.newObject);
};
